import { concatClasses } from "../../../helpers/concatClasses/index.js";
const btnSizeMap = {
  small: "w-24 h-24",
  medium: "w-36 h-36",
  large: "w-40 h-40"
};
const focusShadowMapNeutral = {
  small: "focus-visible:shadow-focus-neutral-sm",
  medium: "focus-visible:shadow-focus-neutral-sm",
  large: "focus-visible:shadow-focus-neutral-md"
};
const focusShadowMapSecondary = {
  small: "focus-visible:shadow-focus-secondary-sm",
  medium: "focus-visible:shadow-focus-secondary-sm",
  large: "focus-visible:shadow-focus-secondary-md"
};
const getButtonClasses = ({ dsf_size, dsf_level, disabled }) => {
  const classes = ["dsf-text-s flex items-center justify-center rounded-m outline-none relative"];
  classes.push(btnSizeMap[dsf_size]);
  if (!disabled) {
    classes.push(dsf_level === "neutral" ? "hover:bg-neutral-50" : "hover:bg-secondary-100");
  }
  classes.push(
    dsf_level === "neutral" ? focusShadowMapNeutral[dsf_size] : focusShadowMapSecondary[dsf_size]
  );
  if (!disabled) {
    classes.push(
      dsf_level === "neutral" ? "active:shadow-[inset_0px_0px_calc(0.6*var(--dsf-base-size))_rgba(0,0,0,0.09)]" : "active:shadow-[inset_0px_0px_calc(0.6*var(--dsf-base-size))_rgba(0,38,77,0.1)]"
    );
  }
  return concatClasses(classes);
};
const iconSizeMap = {
  small: "w-16 h-16",
  medium: "w-24 h-24",
  large: "w-32 h-32"
};
const getIconClasses = ({ dsf_size, dsf_level, disabled }) => {
  const classes = [];
  if (disabled) {
    classes.push(dsf_level === "neutral" ? "text-neutral-400" : "text-secondary-100");
  } else {
    classes.push(dsf_level === "neutral" ? "text-neutral-700" : "text-secondary-300");
  }
  classes.push(iconSizeMap[dsf_size]);
  return concatClasses(classes);
};
export {
  getButtonClasses,
  getIconClasses
};
